import {combineEpics, ofType, OKDialogActions, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";

import {CreateSouscriptionActions} from "../CreateSouscriptionActions";
import {CurrentModuleId} from "../CurrentModuleId";
import {map} from "rxjs/operators";
import {souscriptionCGPWServiceActions} from "../../../services/ws/SouscriptionCGP/souscriptionCGPWServiceActions";


const createSelfcareSimulationSucceededEpic : PledgerEpic<any> = (actions$,state$) =>
    actions$.pipe(
        ofType(souscriptionCGPWServiceActions.CREATE_SOUSCRIPTION_SELFCARE_SIMULATION_SUCCEEDED_ACTION.type),
        map((action : PledgerAction) => {
            const appContext = state$.value.appContext;
            const customColors = appContext.customColors;
            return OKDialogActions.SHOW_OKDIALOG_ACTION.build("Un email a été envoyé au client afin qu'il puisse simuler et souscrire à une offre de crédit", 'Enregistrement réussi',
                customColors.PLEDGER_GREEN_COLOR,customColors.PLEDGER_GREEN_SHADOW_COLOR,CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.build(CurrentModuleId.MAIN));
        }));

const createSelfcareSimulationFailedEpic : PledgerEpic<any> = (actions$,state$) =>
    actions$.pipe(
        ofType(souscriptionCGPWServiceActions.CREATE_SOUSCRIPTION_SELFCARE_SIMULATION_FAILED_ACTION.type),
        map((action : PledgerAction) => {
            const appContext = state$.value.appContext;
            const customColors = appContext.customColors;
            return OKDialogActions.SHOW_OKDIALOG_ACTION.build('Une erreur est survenue', 'Enregistrement échoué', customColors.PLEDGER_GREEN_COLOR,customColors.PLEDGER_GREEN_SHADOW_COLOR,
                OKDialogActions.CLOSE_OKDIALOG_ACTION.build());
        }));


export const souscriptionSelfcareEpics = combineEpics(
    createSelfcareSimulationSucceededEpic,
    createSelfcareSimulationFailedEpic
);
